module.exports = __webpack_public_path__ + "media/svg/instagram-4b74d379.svg";